import PageLayout from './components/page-layout';

// Individual pages
import IndexPage from './pages/landing/';
import Splash from './components/splash-loader/index';
import analytics from './analytics'

function loadSpinner() {
  let $splashDiv = document.getElementById('splash');
  if (!$splashDiv) {
    $splashDiv = document.createElement('div');
    $splashDiv.setAttribute('id', 'splash');
    const $root = document.body.querySelector('#root');
    $root.appendChild($splashDiv);
  }
  m.render($splashDiv, m(Splash));
}
function hideSpinner() {
  let $splashDiv = document.getElementById('splash');
  if ($splashDiv) {
    m.render($splashDiv, null);
  }
}


const Routes = {
  '/splash': {
    render: function() {
      return m(PageLayout, m(Splash));
    },
  },
  '/index': {
    async onmatch() {
      // Show Loader until the promise has been resolved or rejected.
      loadSpinner();
      analytics.page();
    },
    render(vnode) {
      hideSpinner();
      if (typeof vnode.tag === 'function') {
        //If onmatch returns a component or a promise that resolves to a component, comes here.
        return vnode;
      }
      return m(IndexPage);
    },
  },
};

const DefaultRoute = '/index';

export { Routes, DefaultRoute };
